export default __webpack_public_path__ + "a1c4a3e396083be403de5783b138d9ef.svg";